import React from 'react'
import Dialog from '~/components/Dialog'
import { formatNumber } from '~/utils/helpers'

interface ValidationItem {
  phaseName: string
  value: number
  min: number
  max: number
}

interface Props {
  isOpen: boolean
  warnings: ValidationItem[]
  errors: ValidationItem[]
  handleClose: () => void
  handleContinue: () => void
}

const YoungCattleFeedValidationModal: React.FC<Props> = (props) => {
  const { isOpen, warnings, errors, handleClose, handleContinue } = props
  const hasErrors = errors.length > 0
  const hasWarnings = warnings.length > 0

  return <Dialog
    textHeader={hasErrors ? 'Futtermengenwerte' : 'Warnung'}
    isDialogOpen={isOpen}
    textClose={'Abbrechen'}
    textSubmit={hasErrors ? undefined : 'Fortfahren'}
    handleClose={handleClose}
    handleSubmit={hasErrors ? undefined : handleContinue}
    textContent={
      <div style={{ textAlign: 'center' }}>
        {hasErrors && (
          <div style={{ marginBottom: hasWarnings ? 20 : 0 }}>
            <div style={{ fontWeight: 'bold', color: '#9f3a38', marginBottom: 10 }}>
              {'Die folgenden Aufzuchtphasen haben Futtermengenwerte außerhalb des zulässigen Bereichs:'}
            </div>
            {errors.map((error, index) => (
              <div key={index} style={{ color: '#9f3a38', marginBottom: 5 }}>
                <strong>{error.phaseName}</strong>: {formatNumber(error.value)} kg FM/Tier u. Tag
                ({`zulässig: ${formatNumber(error.min)} - ${formatNumber(error.max)} kg FM/Tier u. Tag`})
              </div>
            ))}
          </div>
        )}
        {hasWarnings && (
          <div>
            <div style={{ fontWeight: 'bold', color: '#f2711c', marginBottom: 10 }}>
              {'Die folgenden Aufzuchtphasen haben Futtermengenwerte außerhalb des empfohlenen Bereichs:'}
            </div>
            {warnings.map((warning, index) => (
              <div key={index} style={{ color: '#f2711c', marginBottom: 5 }}>
                <strong>{warning.phaseName}</strong>: {formatNumber(warning.value)} kg FM/Tier u. Tag
                ({`empfohlen: ${formatNumber(warning.min)} - ${formatNumber(warning.max)} kg FM/Tier u. Tag`})
              </div>
            ))}
          </div>
        )}
        {hasErrors && (
          <div style={{ marginTop: 15, fontStyle: 'italic' }}>
            {'Bitte passen Sie die Futterwerte an, bevor Sie fortfahren.'}
          </div>
        )}
      </div>
    }
  />
}

export default YoungCattleFeedValidationModal
